"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const MenuAdmin_1 = __importDefault(require("./navBar/HeaderAdmin/MenuAdmin"));
const SidebarAdmin_1 = __importDefault(require("./navBar/SidebarAdmin/SidebarAdmin"));
const HeaderAdmin_1 = __importDefault(require("./navBar/HeaderAdmin/HeaderAdmin"));
const AdminLayout = () => {
    return (react_1.default.createElement("div", { className: "container-fluid body-background-dashboard" },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement(MenuAdmin_1.default, null),
            react_1.default.createElement("div", { className: "nav-container no-view-mobile" },
                react_1.default.createElement(SidebarAdmin_1.default, null)),
            react_1.default.createElement("div", { className: "content-position-after-header px-0 h-90vh position-relative page-content-base-container" },
                react_1.default.createElement("div", { className: "admin-page-container-layout admin-page-container-height" },
                    react_1.default.createElement("div", { className: "container-header" },
                        react_1.default.createElement(HeaderAdmin_1.default, null)),
                    react_1.default.createElement(react_router_dom_1.Outlet, null)))),
        react_1.default.createElement("div", { className: "row web-cgu-row" },
            react_1.default.createElement("div", { className: "col-lg-4 offset-lg-8 web-cgu-col" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/conditions-generales-d-utilisation", className: "cgu-page-link", target: "_blank" }, "Conditions G\u00E9n\u00E9rales d'Utilisation")))));
};
exports.default = AdminLayout;
